var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "fixBottom", staticClass: "popup px-16 py-24 p-md-24 p-lg-56" },
    [
      _c("div", {
        staticClass: "close",
        on: {
          click: function($event) {
            return _vm.$emit("close")
          }
        }
      }),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade", mode: "out-in" } }, [
        _vm.page == null || _vm.page === "start"
          ? _c("div", { key: "start" }, [
              _c("h2", { staticClass: "mb-32" }, [
                _vm._v(_vm._s(_vm.translations.add_item_popup.title))
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "mb-24" }, [
                _vm._v(_vm._s(_vm.translations.add_item_popup.description))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "options mb-n24" }, [
                _c(
                  "div",
                  {
                    staticClass: "link-item list-item",
                    on: {
                      click: function($event) {
                        _vm.page = "activity"
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "icon" }, [
                      _vm._v(
                        _vm._s(_vm.translations.day_planning.activity.icon)
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "mb-8 title" }, [
                      _vm._v(
                        _vm._s(_vm.translations.day_planning.activity.label)
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "subtitle" }, [
                      _vm._v(
                        _vm._s(
                          _vm.translations.day_planning.activity.description
                        )
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "link-item list-item",
                    on: {
                      click: function($event) {
                        _vm.page = "catering"
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "icon" }, [
                      _vm._v(
                        _vm._s(_vm.translations.day_planning.catering.icon)
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "mb-8 title" }, [
                      _vm._v(
                        _vm._s(_vm.translations.day_planning.catering.label)
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "subtitle" }, [
                      _vm._v(
                        _vm._s(
                          _vm.translations.day_planning.catering.description
                        )
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "link-item list-item",
                    on: {
                      click: function($event) {
                        _vm.page = "break"
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "icon" }, [
                      _vm._v(_vm._s(_vm.translations.day_planning.break.icon))
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "mb-8 title" }, [
                      _vm._v(_vm._s(_vm.translations.day_planning.break.label))
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "subtitle" }, [
                      _vm._v(
                        _vm._s(_vm.translations.day_planning.break.description)
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "link-item list-item",
                    on: {
                      click: function($event) {
                        _vm.page = "own_activity"
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "icon" }, [
                      _vm._v(
                        _vm._s(_vm.translations.day_planning.own_activity.icon)
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "mb-8 title" }, [
                      _vm._v(
                        _vm._s(_vm.translations.day_planning.own_activity.label)
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "subtitle" }, [
                      _vm._v(
                        _vm._s(
                          _vm.translations.day_planning.own_activity.description
                        )
                      )
                    ])
                  ]
                )
              ])
            ])
          : _vm.page === "activity"
          ? _c("div", { key: "activity", staticClass: "add-activity" }, [
              _c("div", { staticClass: "d-flex" }, [
                _c(
                  "a",
                  {
                    staticClass: "back",
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.goBack($event)
                      }
                    }
                  },
                  [
                    _c("span", {
                      domProps: { innerHTML: _vm._s(_vm.svg("arrow-back")) }
                    })
                  ]
                ),
                _vm._v(" "),
                _c("h2", { staticClass: "mb-32" }, [
                  _vm._v(_vm._s(_vm.translations.add_item_popup.activity.title))
                ])
              ]),
              _vm._v(" "),
              _c("p", {
                staticClass: "mb-24",
                domProps: {
                  innerHTML: _vm._s(
                    _vm.translations.add_item_popup.activity.description
                  )
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "row mb-16" },
                _vm._l(_vm.items.activity, function(activity) {
                  return _c("div", { key: activity.id, staticClass: "col-6" }, [
                    _c(
                      "div",
                      {
                        staticClass: "activity mb-32",
                        on: {
                          click: function($event) {
                            return _vm.addActivityToHoverState({
                              type: "activity",
                              data: activity
                            })
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "ar mb-8",
                            style: {
                              "padding-top":
                                (_vm.arHeight / _vm.arWidth) * 100 + "%"
                            }
                          },
                          [
                            _c("img", {
                              attrs: {
                                src:
                                  activity.acf.content.images[0].sizes
                                    .medium_large,
                                alt: activity.post_name
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c("p", {
                          staticClass: "title",
                          domProps: {
                            innerHTML: _vm._s(
                              activity.post_title
                                ? activity.post_title
                                : activity.title.rendered
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "tag-row mt-12" }, [
                          _c("div", { staticClass: "tag-col" }, [
                            _c(
                              "div",
                              { staticClass: "tag tag-accent-light tag-xs" },
                              [_vm._v("Activiteit")]
                            )
                          ])
                        ])
                      ]
                    )
                  ])
                }),
                0
              ),
              _vm._v(" "),
              _c("h2", { staticClass: "mb-32" }, [
                _vm._v(
                  _vm._s(_vm.translations.add_item_popup.activity.extras_title)
                )
              ]),
              _vm._v(" "),
              _c("p", {
                staticClass: "mb-24",
                domProps: {
                  innerHTML: _vm._s(
                    _vm.translations.add_item_popup.activity.extras_description
                  )
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "row mb-n32" },
                [
                  _vm._l(_vm.items.speaker, function(speaker) {
                    return _c(
                      "div",
                      { key: speaker.id, staticClass: "col-6" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "activity mb-32",
                            on: {
                              click: function($event) {
                                return _vm.addActivityToHoverState({
                                  type: "speaker",
                                  data: speaker
                                })
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "ar mb-8",
                                style: {
                                  "padding-top":
                                    (_vm.arHeight / _vm.arWidth) * 100 + "%"
                                }
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: speaker.acf.image.sizes.medium_large,
                                    alt: speaker.post_name
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c("p", {
                              staticClass: "title",
                              domProps: {
                                innerHTML: _vm._s(speaker.title.rendered)
                              }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "tag-row mt-12" }, [
                              _c("div", { staticClass: "tag-col" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "tag tag-accent-light tag-xs"
                                  },
                                  [_vm._v("Spreker")]
                                )
                              ])
                            ])
                          ]
                        )
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.items.location, function(location) {
                    return _c(
                      "div",
                      { key: location.id, staticClass: "col-6" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "activity mb-32",
                            on: {
                              click: function($event) {
                                return _vm.addActivityToHoverState({
                                  type: "location",
                                  data: location
                                })
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "ar mb-8",
                                style: {
                                  "padding-top":
                                    (_vm.arHeight / _vm.arWidth) * 100 + "%"
                                }
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: location.acf.image.sizes.medium_large,
                                    alt: location.post_name
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c("p", {
                              staticClass: "title",
                              domProps: {
                                innerHTML: _vm._s(location.title.rendered)
                              }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "tag-row mt-12" }, [
                              _c("div", { staticClass: "tag-col" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "tag tag-accent-light tag-xs"
                                  },
                                  [_vm._v("Locatie")]
                                )
                              ])
                            ])
                          ]
                        )
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.items.staticItem, function(staticItem) {
                    return _c(
                      "div",
                      { key: staticItem.id, staticClass: "col-6" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "activity mb-32",
                            on: {
                              click: function($event) {
                                return _vm.addActivityToHoverState({
                                  type: "staticItem",
                                  data: staticItem
                                })
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "ar mb-8",
                                style: {
                                  "padding-top":
                                    (_vm.arHeight / _vm.arWidth) * 100 + "%"
                                }
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src:
                                      staticItem.acf.image.sizes.medium_large,
                                    alt: staticItem.post_name
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c("p", {
                              staticClass: "title",
                              domProps: {
                                innerHTML: _vm._s(staticItem.post_title)
                              }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "tag-row mt-12" }, [
                              _c("div", { staticClass: "tag-col" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "tag tag-accent-light tag-xs"
                                  },
                                  [_vm._v("Extra")]
                                )
                              ])
                            ])
                          ]
                        )
                      ]
                    )
                  })
                ],
                2
              )
            ])
          : _vm.page === "break"
          ? _c(
              "div",
              { key: "break" },
              [
                _c("div", { staticClass: "d-flex" }, [
                  _c(
                    "a",
                    {
                      staticClass: "back",
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.goBack($event)
                        }
                      }
                    },
                    [
                      _c("span", {
                        domProps: { innerHTML: _vm._s(_vm.svg("arrow-back")) }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("h2", { staticClass: "mb-32" }, [
                    _vm._v(_vm._s(_vm.translations.add_item_popup.break.title))
                  ])
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "mb-24" }, [
                  _vm._v(
                    _vm._s(_vm.translations.add_item_popup.break.description)
                  )
                ]),
                _vm._v(" "),
                _c("ValidationObserver", {
                  ref: "observer",
                  attrs: { tag: "div", slim: true },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(ref) {
                        var invalid = ref.invalid
                        return [
                          _c("el-input", {
                            staticClass: "mb-24",
                            attrs: {
                              type: "textarea",
                              label:
                                _vm.translations.add_item_popup.break.remark,
                              rules: ""
                            },
                            model: {
                              value: _vm.pause.remarks,
                              callback: function($$v) {
                                _vm.$set(_vm.pause, "remarks", $$v)
                              },
                              expression: "pause.remarks"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "d-flex align-items-center mb-24",
                              on: {
                                click: function($event) {
                                  _vm.pause.needs_catering = !_vm.pause
                                    .needs_catering
                                }
                              }
                            },
                            [
                              _c("el-checkbox", {
                                attrs: { value: _vm.pause.needs_catering }
                              }),
                              _vm._v(" "),
                              _c("p", { staticClass: "ml-12 clickable" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.translations.add_item_popup.break
                                      .add_catering
                                  )
                                )
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.showCateringField
                            ? [
                                _c("el-input", {
                                  staticClass: "mb-24",
                                  attrs: {
                                    type: "textarea",
                                    label:
                                      _vm.translations.add_item_popup.break
                                        .catering,
                                    placeholder:
                                      _vm.translations.add_item_popup.break
                                        .remark,
                                    rules: "required"
                                  },
                                  model: {
                                    value: _vm.pause.catering,
                                    callback: function($$v) {
                                      _vm.$set(_vm.pause, "catering", $$v)
                                    },
                                    expression: "pause.catering"
                                  }
                                })
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex mt-40 justify-content-between align-items-center"
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-accent text-white",
                                  attrs: {
                                    type: "submit",
                                    disabled: invalid || _vm.success
                                  },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.addBreak($event)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.translations.add_item_popup.break.save
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.$emit("close")
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.translations.add_item_popup.break
                                        .cancel
                                    )
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          : _vm.page === "catering"
          ? _c("div", { key: "catering", staticClass: "catering" }, [
              _c("div", { staticClass: "d-flex" }, [
                _c(
                  "a",
                  {
                    staticClass: "back",
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.goBack($event)
                      }
                    }
                  },
                  [
                    _c("span", {
                      domProps: { innerHTML: _vm._s(_vm.svg("arrow-back")) }
                    })
                  ]
                ),
                _vm._v(" "),
                _c("h2", { staticClass: "mb-32" }, [
                  _vm._v(_vm._s(_vm.translations.add_item_popup.catering.title))
                ])
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "mb-24" }, [
                _vm._v(
                  _vm._s(_vm.translations.add_item_popup.catering.description)
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "options mb-16" }, [
                _c(
                  "div",
                  {
                    staticClass: "list-item",
                    on: {
                      click: function($event) {
                        _vm.catering.breakfast = !_vm.catering.breakfast
                      }
                    }
                  },
                  [
                    _c("el-checkbox", {
                      attrs: { value: _vm.catering.breakfast }
                    }),
                    _vm._v(" "),
                    _c("p", { staticClass: "mb-8 title pl-16" }, [
                      _vm._v(
                        _vm._s(
                          _vm.translations.add_item_popup.catering
                            .breakfast_title
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "subtitle pl-16" }, [
                      _vm._v(
                        _vm._s(
                          _vm.translations.add_item_popup.catering
                            .breakfast_description
                        )
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "list-item",
                    on: {
                      click: function($event) {
                        _vm.catering.lunch = !_vm.catering.lunch
                      }
                    }
                  },
                  [
                    _c("el-checkbox", { attrs: { value: _vm.catering.lunch } }),
                    _vm._v(" "),
                    _c("p", { staticClass: "mb-8 title pl-16" }, [
                      _vm._v(
                        _vm._s(
                          _vm.translations.add_item_popup.catering.lunch_title
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "subtitle pl-16" }, [
                      _vm._v(
                        _vm._s(
                          _vm.translations.add_item_popup.catering
                            .lunch_description
                        )
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "list-item",
                    on: {
                      click: function($event) {
                        _vm.catering.snack = !_vm.catering.snack
                      }
                    }
                  },
                  [
                    _c("el-checkbox", { attrs: { value: _vm.catering.snack } }),
                    _vm._v(" "),
                    _c("p", { staticClass: "mb-8 title pl-16" }, [
                      _vm._v(
                        _vm._s(
                          _vm.translations.add_item_popup.catering.snack_title
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "subtitle pl-16" }, [
                      _vm._v(
                        _vm._s(
                          _vm.translations.add_item_popup.catering
                            .snack_description
                        )
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "list-item",
                    on: {
                      click: function($event) {
                        _vm.catering.dinner = !_vm.catering.dinner
                      }
                    }
                  },
                  [
                    _c("el-checkbox", {
                      attrs: { value: _vm.catering.dinner }
                    }),
                    _vm._v(" "),
                    _c("p", { staticClass: "mb-8 title pl-16" }, [
                      _vm._v(
                        _vm._s(
                          _vm.translations.add_item_popup.catering.dinner_title
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "subtitle pl-16" }, [
                      _vm._v(
                        _vm._s(
                          _vm.translations.add_item_popup.catering
                            .dinner_description
                        )
                      )
                    ])
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "btn btn-accent text-white",
                  on: { click: _vm.addCatering }
                },
                [_vm._v(_vm._s(_vm.translations.add_item_popup.catering.add))]
              )
            ])
          : _vm.page === "own_activity"
          ? _c(
              "div",
              { key: "own_activity" },
              [
                _c("div", { staticClass: "d-flex" }, [
                  _c(
                    "a",
                    {
                      staticClass: "back",
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.goBack($event)
                        }
                      }
                    },
                    [
                      _c("span", {
                        domProps: { innerHTML: _vm._s(_vm.svg("arrow-back")) }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("h2", { staticClass: "mb-32" }, [
                    _vm._v(
                      _vm._s(_vm.translations.add_item_popup.own_activity.title)
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "mb-24" }, [
                  _vm._v(
                    _vm._s(
                      _vm.translations.add_item_popup.own_activity.description
                    )
                  )
                ]),
                _vm._v(" "),
                _c("ValidationObserver", {
                  ref: "observer",
                  attrs: { tag: "div", slim: true },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(ref) {
                        var invalid = ref.invalid
                        return [
                          _c("el-input", {
                            staticClass: "mb-24",
                            attrs: {
                              type: "text",
                              label:
                                _vm.translations.add_item_popup.own_activity
                                  .name,
                              rules: "required"
                            },
                            model: {
                              value: _vm.own_activity.name,
                              callback: function($$v) {
                                _vm.$set(_vm.own_activity, "name", $$v)
                              },
                              expression: "own_activity.name"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-input", {
                            staticClass: "mb-24",
                            attrs: {
                              type: "textarea",
                              label:
                                _vm.translations.add_item_popup.own_activity
                                  .remark,
                              rules: ""
                            },
                            model: {
                              value: _vm.own_activity.remarks,
                              callback: function($$v) {
                                _vm.$set(_vm.own_activity, "remarks", $$v)
                              },
                              expression: "own_activity.remarks"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "d-flex align-items-center mb-24",
                              on: {
                                click: function($event) {
                                  _vm.own_activity.has_requests = !_vm
                                    .own_activity.has_requests
                                }
                              }
                            },
                            [
                              _c("el-checkbox", {
                                attrs: { value: _vm.own_activity.has_requests }
                              }),
                              _vm._v(" "),
                              _c("p", { staticClass: "ml-12 clickable" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.translations.add_item_popup.own_activity
                                      .need_help
                                  )
                                )
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.showRequestField
                            ? [
                                _c("el-input", {
                                  staticClass: "mb-24",
                                  attrs: {
                                    type: "textarea",
                                    label:
                                      _vm.translations.add_item_popup
                                        .own_activity.need_help_title,
                                    placeholder:
                                      _vm.translations.add_item_popup
                                        .own_activity.need_help_field,
                                    rules: "required"
                                  },
                                  model: {
                                    value: _vm.own_activity.requests,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.own_activity,
                                        "requests",
                                        $$v
                                      )
                                    },
                                    expression: "own_activity.requests"
                                  }
                                })
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex mt-40 justify-content-between align-items-center"
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-accent text-white",
                                  attrs: {
                                    type: "submit",
                                    disabled: invalid || _vm.success
                                  },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.addOwnActivity($event)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.translations.add_item_popup
                                        .own_activity.save
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.$emit("close")
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.translations.add_item_popup
                                        .own_activity.cancel
                                    )
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }